import './styles.scss';

const Results = ({ children }) => {
  return <section className="results">{children}</section>;
};

export default Results;
